import { Icon, Id, TextButton, Trigger } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EvaluatedFeedbackFreeTextQuestionResource } from "../types/feedback";
import { FeedbackFreeTextAnswersDrawer } from "./FeedbackFreeTextAnswersDrawer";

interface Props {
	eventId: Id;
	question: EvaluatedFeedbackFreeTextQuestionResource;
}
export const CompactFeedbackFreeTextQuestionEvaluation: FC<Props> = ({ eventId, question }) => {
	const { t } = useTranslation();
	return (
		<Trigger render={(props) => <FeedbackFreeTextAnswersDrawer {...props} eventId={eventId} question={question} />}>
			{(props) => (
				<div>
					<TextButton {...props} type="button" size="small" prefix={<Icon $icon="arrow_outward" />}>
						{t("Show all {{number}} answers", { number: question.evaluation })}
					</TextButton>
				</div>
			)}
		</Trigger>
	);
};
